import { theme } from '@jadwalh/ui';
import styled from 'styled-components';

export const PopUpEditWapper = styled.div`
  form {
    .header {
      margin-bottom: 16px;
    }
    label {
      p {
        color: ${theme.colours.blackText};
      }
      input {
        background-color: ${theme.colours.Lotion};
        border: 1px solid ${theme.colours.BrightGray} !important;
        border-radius: 12px;
        &:lang(ar) {
          text-align: right;
        }
      }
    }
    input {
      background-color: ${theme.colours.Lotion};
      border: 1px solid ${theme.colours.BrightGray};
      border-radius: 12px;
      height: 40px;
    }

    .Header {
      color: ${theme.colours.black};
      font-family: ${theme.fonts.Medium};
      font-weight: 600;
      font-size: 24px;
    }
    .mantine-Select-input {
      padding-inline-end: 12px;
    }
    .inputWrapper {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 10px;
      > div {
        width: 100%;
        height: 93px;
      }
      button {
        height: 41px;
        padding: 8px 30px;
        border-radius: 12px;
        border: 1px solid ${theme.colours.AntiFlashWhite};
        font-family: ${theme.fonts.Regular};
        font-size: 14px;
        background-color: ${theme.colours.AntiFlashWhite};
        margin-bottom: 7px;
        color: ${theme.colours.black};
      }
      input {
        direction: ltr;
        &:lang(ar) {
          text-align: right;
        }
      }
    }
    .hint {
      margin-bottom: 10px;
      line-height: 22px;
      text-align: initial;
      min-height: 32px;
      p {
        background-color: ${theme.colours.warnning_color};
        color: ${theme.colours.warnning_text_color};
        padding: 7px 12px;
        font-size: 13px;
        border-radius: 8px;
        font-family: ${theme.fonts.Regular};
      }
    }
  }
`;

export const PopUpWrapper = styled.div`
  padding: 0;
  h2 {
    font-size: 16px;
  }
  .popup-body {
    padding: 16px 24px;
    border-bottom: 1px solid ${theme.colours.newOutline};
    @media (max-width: 768px) {
      padding: 16px !important;
    }
  }
  .popup-footer {
    padding: 16px 24px;
    @media (max-width: 768px) {
      padding: 16px !important;
    }
  }

  button {
    padding: 8px 16px;
    min-width: 100px;
    border-radius: 8px;
    width: 80px;
    height: 32px;
    @media (max-width: 768px) {
      width: 100% !important;
    }
    &[type='submit'] {
      background-color: ${theme.colours.blackText};
      color: ${theme.colours.white};
    }
    &:disabled {
      pointer-events: none;
      color: black;
    }
  }

  .cancelBtn {
    background: white;
    border-radius: 8px;
    font-size: 13px;
    border: 0.5px solid ${theme.colours.newOutline};
    color: ${theme.colours.blackText};
    padding: 6px 16px;
    width: 80px;
    height: 32px;
    @media (max-width: 768px) {
      width: 100% !important;
    }
  }
`;

export const ButtonsWrapper = styled.div`
  border-top: 1px solid ${theme.colours.BrightGray};
  .action_container {
    padding: 16px 0 0;
    button {
      border-radius: 12px;
      min-width: 85px;
      height: 32px;
      background-color: ${theme.colours.AntiFlashWhite};
      color: ${theme.colours.black};
      font-weight: 400;
      &[type='submit'] {
        background-color: ${theme.colours.mainBlue};
        color: #fff;
        width: 158px;
      }
      @media (max-width: 767px) {
        width: 50% !important;
      }
    }
  }
`;
